/** Mirrors the page's path, so `/about` has `/og/about.webp` and `/` has `/og/index.webp`. */
export function ogImage(path: string) {
  return `/og${path === '/' ? '/index' : path}.webp`;
}

/** Rendered at this size, and declared at it in `og:image:width`/`height`. */
export const ogImageSize = { width: 1200, height: 630 } as const;
